import type { Authenticate, LoginResponse } from "@/types"

// en dev mode no pide contraseña
type AuthParams = {
    username: string
    password?: string
    id: string
}

export async function authenticate({ id, username, password }: AuthParams): Promise<LoginResponse> {
    try {
        const request = await fetch("/login/authenticate", {
            headers: {
                "Content-Type": "application/json;"
            },
            method: "POST",
            body: JSON.stringify({
                Id: id,
                UserName: username,
                Password: password ?? ""
            })
        })

        if(request.ok) {
            const data: Authenticate = await request.json()
            return { data }
        }
        
        throw request.status
    } catch (error) {
        console.error(error)
        return { error: `Status ${error}` }
    }
}